<template>
	<div class="page_warp">
		<div class="top_content" style="display: table;justify-content: space-between; margin-bottom: 10px">

			<div class="nav_warp">
				<div class="nav_item" :class="checkExoType == 0 ? 'nav_item_ac' : ''" @click="navClick(0)">
					<p>高速费</p>
					<div v-if="checkExoType == 0" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="checkExoType == 1 ? 'nav_item_ac' : ''" @click="navClick(1)">
					<p>路桥费</p>
					<div v-if="checkExoType == 1" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="checkExoType == 2 ? 'nav_item_ac' : ''" @click="navClick(2)">
					<p>燃料费</p>
					<div v-if="checkExoType == 2" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="checkExoType == 3 ? 'nav_item_ac' : ''" @click="navClick(3)">
					<p>维修费</p>
					<div v-if="checkExoType ==3" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="checkExoType == 4 ? 'nav_item_ac' : ''" @click="navClick(4)">
					<p>停车费</p>
					<div v-if="checkExoType == 4" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="checkExoType == 50 ? 'nav_item_ac' : ''" @click="navClick(50)">
					<p>其它费用</p>
					<div v-if="checkExoType == 50" class="nav_item_line"></div>
				</div>
			</div>

			<div style="display: table-row;">
				<div class="flex flex-y-center orderPicker">
					<div class="top_input2">
						<el-select v-model="checkType" placeholder="请选择" @change="checkTypeChange">
							<el-option label="车牌号" value="0"> </el-option>
							<el-option label="发起人" value="1"> </el-option>
							<el-option label="运单号" value="2"> </el-option>
						</el-select>
					</div>
					<div class="top_input3">
						<el-select v-model="checkTypeValue" filterable placeholder="请选择" v-if="checkType!=='2'"
							clearable>
							<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
								:value="item.index">
								<!-- <span style="float: left">{{ item.value }}</span>
								<span style="
								          float: right;
								          color: var(--el-text-color-secondary);
								          font-size: 13px;
								        ">
									{{ item.index }}
								</span> -->
							</el-option>
						</el-select>
						<el-input type="text" placeholder="请输入" v-model="searchWord" v-if="checkType=='2'"></el-input>
					</div>
					<div
						style="display: flex;width: 350px; height: 35px;padding: 0 15px;align-items: center;justify-content: flex-start;">
						费用时间：
						<el-date-picker style="width: 250px; height: 35px" v-model="dayArr" type="datetimerange"
							range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
							@change="getData" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
						</el-date-picker>
					</div>


					<div class="search_btn" @click="getData">查询</div>
					<div class="add_btn" @click="add">添加</div>
					<el-upload class="upload" action="#" :show-file-list="false" :on-change="handleExcel"
						accept="'.xlsx','.xls'" :auto-upload="false">
						<div class="add_btn" v-if="permissionItem.import">导入</div>
					</el-upload>

				</div>
			</div>
		</div>
		<div class="bottom_content2">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" highlight-current-row @current-change="handleCurrentChange">
					<el-table-column prop="exoNo" label="费用单号" width="110"></el-table-column>
					<el-table-column prop="vehNo" label="车牌号" width="110"></el-table-column>
					<el-table-column prop="exoAdvanceUserName" label="发起人" width="110"></el-table-column>
					<el-table-column prop="itemList[0].exoiPayTime" label="费用时间" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiName" label="费用子项" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiCount" label="数量" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiSumPrice" label="金额" width="120"></el-table-column>
					<el-table-column prop="exoAdvanceType" label="支付类型" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoAdvanceType == '0'">公司定点费用</span>
							<span v-else-if="scope.row.exoAdvanceType == '1'">垫付</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="exoChkStatus" label="审核状态" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoChkStatus == '0'" style="color: #E36A19;">未审核</span>
							<span v-else-if="scope.row.exoChkStatus == '1'">审核通过</span>
							<span v-else-if="scope.row.exoChkStatus == '2'" style="color: #E36A19;">审核驳回</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="exoEaStatus" label="报销状态" width="120">
						<template #default="scope">
							<span v-if="scope.row.exoAdvanceType == '0'">不用报销</span>
							<span v-else-if="scope.row.exoEaStatus == '0'" style="color: #E36A19;">未报销</span>
							<span v-else-if="scope.row.exoEaStatus == '1'">已报销</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="exoOdrId" label="关联运单" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiDescribe" label="说明" width="100"></el-table-column>
					<el-table-column prop="itemList[0].exoiOdometer" label="表显里程" width="120"></el-table-column>
					<el-table-column prop="itemList[0].exoiPayAddr" label="地址" width="300">
						<template #default="scope">
							<div class="cell-style">{{ scope.row.itemList[0].exoiPayAddr }}</div>
						</template>
					</el-table-column>
					<el-table-column width="180" fixed="right" label="操作">
						<template #default="scope">
							<!-- <span class="default_color pointer m-right10" v-on:click="edit(scope.row.lorId)">编辑</span> -->
							<span class="default_color pointer m-right10" v-on:click="detail(scope.row.exoId)">详情</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-around">
				<div class="mr-10" style="font-size: 14px; display: inline-block">
					费用单量:<span style="color: red">{{ exoSumCount }}</span>，费用汇总:<span
						style="color: red">￥{{ exoSumMoney.toFixed(2) }}</span>，待审核费用：<span
						style="color: red">￥{{ exoWaitChkMoney.toFixed(2) }}</span>，待报销费用：<span
						style="color: red">￥{{ exoWaitPayMoney.toFixed(2) }}</span>
				</div>
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "costManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();
			
			const currentRow = ref();

			const data = reactive({
				tableId: "roleManagementTable",
				checkExoType: "0",
				checkType: "0",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				changeLorstatus: "", //运单进度：空为全部 0待接单，1进行中，2已完成，3已关闭，10待审核
				orderNum: null,
				dayArr: [],
				checkTypeValue: "",
				checkTypeList: [],
				exoVehId: "",
				exoAdvanceUserid: "",
				exoOdrId: "",
				exoSumCount: 0,
				exoSumMoney: 0,
				exoWaitPayMoney: 0,
				exoWaitChkMoney: 0,

				permissionItem: {
					list: false,
					export: false,
					import: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "costManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "costManage:export") {
						data.permissionItem.export = true;
					}
					if (el == "costManage:import") {
						data.permissionItem.import = true;
					}
				});

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight - 40;

					//data.dayArr = get24hoursRangeTime();
					checkTypeChange('0');
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							"bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询列表权限！");
					return;
				}

				console.log(data.dayArr);
				if (data.checkType == "0") {
					data.exoVehId = data.checkTypeValue;
					data.exoAdvanceUserid = "";
					data.exoOdrId = "";
				} else if (data.checkType == "1") {
					data.exoVehId = "";
					data.exoAdvanceUserid = data.checkTypeValue;
					data.exoOdrId = "";
				} else if (data.checkType == "2") {
					data.exoVehId = "";
					data.exoAdvanceUserid = "";
					data.exoOdrId = data.searchWord;
				}

				let params = {
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkExoType, //费用类型
					exoChkStatus: "1", //审核状态：0未审核；1通过；2不通过
					exoEaStatus: "", //报销状态：0未报销；1已报销
					exoVehId: data.exoVehId,
					exoAdvanceUserid: data.exoAdvanceUserid,
					exoOdrId: data.exoOdrId,
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderList, params);
				console.log(r);
				if (r.code === 0) {
					data.tableData = r.rows;
					data.totalCount = r.total;
					
					getListSum();//获取汇总统计数据
				}

			};

			//获取汇总统计数据
			const getListSum = async () => {

				if (data.checkType == "0") {
					data.exoVehId = data.checkTypeValue;
					data.exoAdvanceUserid = "";
					data.exoOdrId = "";
				} else if (data.checkType == "1") {
					data.exoVehId = "";
					data.exoAdvanceUserid = data.checkTypeValue;
					data.exoOdrId = "";
				} else if (data.checkType == "2") {
					data.exoVehId = "";
					data.exoAdvanceUserid = "";
					data.exoOdrId = data.searchWord;
				}

				let params = {
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkExoType, //费用类型
					exoChkStatus: "1", //审核状态：0未审核；1通过；2不通过
					exoEaStatus: "", //报销状态：0未报销；1已报销
					exoVehId: data.exoVehId,
					exoAdvanceUserid: data.exoAdvanceUserid,
					exoOdrId: data.exoOdrId,
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};

				const r = await proxy.$http.get(apiObj.expensesOrderSum, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.exoSumCount = r.odrCount; 
					data.exoSumMoney = r.sumMoney; 
					data.exoWaitPayMoney = r.eaMoney; 
					data.exoWaitChkMoney = r.chkMoney; 
				}

			};

			const get24hoursRangeTime = () => {
				//当前设定的日期时间
				let rangeArr = []; //定义一个装时间的数组
				let d = new Date();
				let year1, month1, day1, hour1, minutes1, seconds1;
				year1 = d.getFullYear();
				month1 = d.getMonth() + 1;
				day1 = d.getDate();
				hour1 = d.getHours();
				minutes1 = d.getMinutes();
				seconds1 = d.getSeconds();
				month1 = month1 < 10 ? '0' + month1 : month1;
				day1 = day1 < 10 ? '0' + day1 : day1;
				hour1 = hour1 < 10 ? '0' + hour1 : hour1;
				minutes1 = minutes1 < 10 ? '0' + minutes1 : minutes1;
				seconds1 = seconds1 < 10 ? '0' + seconds1 : seconds1;
				let value1 = year1 + '-' + month1 + '-' + day1 + ' ' + hour1 + ':' + minutes1 + ':' + seconds1;
				rangeArr.push(value1);
				//前一天设定的日期时间
				let year2, month2, day2, hour2, minutes2, seconds2;
				//getTime() 返回距 1970 年 1 月 1 日之间的毫秒数,setTime设置 Date 对象的日期和时间值
				d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000); //减去一天的毫秒时间，就是前一天的了
				year2 = d.getFullYear();
				month2 = d.getMonth() + 1;
				day2 = d.getDate();
				hour2 = d.getHours();
				minutes2 = d.getMinutes();
				seconds2 = d.getSeconds();
				month2 = month2 < 10 ? '0' + month2 : month2;
				day2 = day2 < 10 ? '0' + day2 : day2;
				hour2 = hour2 < 10 ? '0' + hour2 : hour2;
				minutes2 = minutes2 < 10 ? '0' + minutes2 : minutes2;
				seconds2 = seconds2 < 10 ? '0' + seconds2 : seconds2;
				let value2 = year2 + '-' + month2 + '-' + day2 + ' ' + hour2 + ':' + minutes2 + ':' + seconds2;
				rangeArr.unshift(value2);
				return rangeArr;
			};

			// 添加 根目录
			const add = () => {
				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id) => {
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};

			//切换状态运单
			const changeNav = (val) => {

				data.changeLorstatus = val;

				// this.currentPage = 1;
				// this.tableData = [];
				getData();
			};

			const navClick = (index) => {
				data.checkExoType = index;
				getData();
			};

			const checkTypeChange = async (value) => {
				data.checkTypeValue = "";
				if (value == "0") {
					//获取车辆
					let params = {
						searchWord: "",
						page: 1,
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.vehicleList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.vehHeadNo,
								index: el.vehicleHeadId,
							});
						});
					}
				} else if (value == "1") {
					//获取驾驶员
					let params = {
						searchWord: "",
						offset: "0",
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.drigetList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.driList.forEach((el) => {
							data.checkTypeList.push({
								value: el.driName,
								index: el.driUserId,
							});
						});
					}
				}

			};

			// 导入
			const handleExcel = async (file) => {
				if (!data.permissionItem.import) {
					proxy.$message.error("没有导入权限！");
					return;
				}

				console.log(file);
				let formData = new FormData(); //声明一个FormDate对象
				formData.append("file", file.raw); //把文件信息放入对象中
				//formData.append("advId", this.advId); //把文件信息放入对象中
				console.log(formData);
				//this.upload()
				await proxy.$http.uploadFileRequest(apiObj.importExpenses, formData, {
						headers: {
							'Content-Type': 'application/json'
						}
					}).then(res => {
						// 检查响应类型
						const contentType = res.type;
						if (contentType.includes('application/json')) {
							// 成功情况：返回JSON
							let reader = new FileReader();
							reader.readAsText(res)
							reader.onload = function(result) {
								try {
									let resData = JSON.parse(result.target
										.result); // 解析对象成功，说明是json数据
									if (resData.respCode == 0 || resData.respCode == "0000") {
										proxy.$message.success(resData.msg || resData.respMsg);
										getData();
									} else {
										proxy.$message.error(resData.msg || resData.respMsg);
									}
								} catch (err) { // 解析成对象失败，说明是正常的文件流
									proxy.$message.error(err);
								}
							};

						} else if (contentType.includes('application/octet-stream') ||
							contentType.includes('application/vnd.ms-excel')) {
							// 错误情况：返回文件流（错误报告）
							proxy.$message.error("费用导入有错误，请检查返回EXCEL表！");

							let fileName = "导入费用错误信息" + Date.parse(new Date()) + ".xls"; //这里是文件名
							proxy.$confirm("确定要导出失败的数据吗?", "提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								})
								.then(() => {
									const blob = new Blob([res], {
										type: 'application/vnd.ms-excel'
									});
									if (window.navigator && window.navigator.msSaveOrOpenBlob) {
										window.navigator.msSaveOrOpenBlob(blob, fileName);
									} else {
										const link = document.createElement('a')
										link.style.display = 'none'
										link.href = URL.createObjectURL(blob)
										link.download = fileName
										document.body.appendChild(link)
										link.click()
										document.body.removeChild(link)
									}
								})
						} else {
							throw new Error(`未知的响应类型: ${contentType}`);
						}
					})
					.catch(error => {
						console.log(error);
					});
			};
			
			const handleCurrentChange = (val) => {
				currentRow.value = val
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				changeNav,
				checkTypeChange,
				navClick,
				handleExcel,
				handleCurrentChange,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.orderPicker {
		margin-top: 10px;
		height: 50px;
	}

	.orderPicker .el-range__icon {
		margin-right: 10px !important;
	}

	.cursor {
		cursor: pointer;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		cursor: pointer;
	}

	/* 	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	} */

	/* .nav_item_ac span {
		color: #293787 !important;
	} */

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.nav_item p {
		font-size: 16px;
		color: #666666;
		line-height: 78px;
		margin: 0 15px;
		position: relative;
	}

	.nav_item_ac p {
		color: #293787 !important;
		/* color: #2eb779; */
		cursor: pointer;
	}

	.nav_item p span {
		display: block;
		width: 20px;
		height: 20px;
		background: #ff0000;
		border-radius: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		position: absolute;
		top: 10px;
		right: -10px;
	}

	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}
</style>